import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import Tabs from './tabs';
import TabPane from './tabPane';
import TabContent from './tabContent';

class NewsSiderTabs extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    render() {
        const { content } = this.props;

        return (
            <div className={styles.tabs}>
                <Tabs>
                    {content.map((item, index) => (
                        <TabPane key={index} title={item.title} url={item.url}>
                            <TabContent content={item.data} />
                        </TabPane>
                    ))}
                </Tabs>
            </div>
        );
    }
}

export default errorBoundary(NewsSiderTabs);
